import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TableContext = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

export default TableContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Table/TableContext.js
// module id = 711
// module chunks = 0